import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterAirports'
})
export class FilterAirportsPipe implements PipeTransform {
  transform(airports: any[]): any[] {
    return airports.filter(airport => airport.flightsCount > 0);
  }
}